import TaskItem from '@tiptap/extension-task-item'

/* TaskItem's upstream renderHTML wraps its content in a bare ["div", 0] while
 * its parseHTML omits contentElement. Under enableContentCheck the strict
 * catch-all parse then treats that <div> as an unknown block and rejects the
 * whole document — crashing visit notes seeded from any template containing a
 * checklist. Pointing the parser at the content <div> makes the render→parse
 * round trip lossless, which the server's HTML→JSON leg needs just as much as
 * the editor does. */
export const TaskItemNode = TaskItem.extend({
  parseHTML() {
    return [
      {
        tag: `li[data-type="${this.name}"]`,
        priority: 51,
        contentElement: (element) => {
          const el = element as HTMLElement
          return el.querySelector<HTMLElement>(':scope > div') ?? el
        },
      },
    ]
  },
}).configure({ nested: true })
